import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledPersonTextualInfo } from "./person-textual-info.scss";
import classnames from "classnames";
import DefaultProps from "./default-props";
class PersonTextualInfo extends PureComponent {
    getTextualInfoStyle() {
        const { color } = this.props;
        return {
            color
        };
    }
    render() {
        const { name, jobDescription, className } = this.props;
        return /*#__PURE__*/ _jsxs(StyledPersonTextualInfo, {
            className: classnames("person-textual-info", className),
            style: this.getTextualInfoStyle(),
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "person-name",
                    children: name
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "seperator",
                    children: " | "
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "person-job-description",
                    children: jobDescription
                })
            ]
        });
    }
}
export { PersonTextualInfo as default };
PersonTextualInfo.defaultProps = DefaultProps;
